import api from './api'

const SUB_URL = '/runs'

export const getRunIds = async (moa: string) => {
  try {
      const response = await api.post(`${SUB_URL}/id/all`, {moa: moa});
      return response.data
    } catch (error) {
      console.error('Error fetching run ids:', error);
    }
};

export const getParams = async (run_id: string, moa: string) => {
  try {
      const response = await api.post(`${SUB_URL}/params`, {run_id: run_id, moa: moa});
      console.log(response.data)
      return response.data
    } catch (error) {
      console.error('Error fetching params:', error);
    }
};

export const getScores = async (run_id: string, moa: string) => {
    try {
        const response = await api.post(`${SUB_URL}/scores`, {run_id: run_id, moa: moa});
        return response.data
      } catch (error) {
        console.error('Error fetching scores:', error);
      }
  };
